import React, { useContext, useEffect } from "react";
import { withRouter } from "react-router-dom";
import {} from "react-router";
import logo from "../assets/images/logo.png";
import { AuthContext } from "../utilities/authContext";
import Icon from "./Icon";
import { FlexWrapper, StyledText } from "./StyledComponents";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { setUserData } from "../actions/user-action-types";

const Header = () => {
  const dispatch = useDispatch();
  const { logout } = useContext(AuthContext);
  const userData = useSelector((state) => state.user.userData);
  const name = userData?.name ?? "";
  const role = userData?.Role?.name ?? "";

  useEffect(() => {
    if (
      !isEmpty(localStorage.getItem("userData")) &&
      localStorage.getItem("userData") !== undefined
    ) {
      const useDataJson = JSON.parse(localStorage.getItem("userData"));
      dispatch(setUserData(useDataJson));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem("userData")]);

  return (
    <div
      style={{
        height: "80px",
        // backgroundColor: "#003E85",
        flexDirection: "row",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "30px",
        paddingRight: "40px",
        borderBottom: "1px solid #ececec",
      }}
    >
      <div
        style={{
          // backgroundColor: "#003E85",
          height: "80px",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <img
          src={logo}
          style={{ alignSelf: "center", width: 194, height: 71 }}
        />
      </div>
      <FlexWrapper
        direction="row"
        alignItems="center"
        style={{ maxWidth: 260 }}
      >
        <FlexWrapper>
          <StyledText fontSize="14px" fontWeight="600" color="#000">
            {"Welcome"}: {name}
          </StyledText>
          <StyledText fontSize="14px" color="#000">
            {role}
          </StyledText>
        </FlexWrapper>
        <div
          onClick={async () => {
            localStorage.removeItem("token");
            localStorage.removeItem("LastTokenRefresh");
            localStorage.removeItem("LastLogin");
            localStorage.removeItem("userData");
            logout();
          }}
          style={{ cursor: "pointer" }}
        >
          <Icon width="20" icon="Logout" color="#000" height="20" />
        </div>
      </FlexWrapper>
    </div>
  );
};

export default withRouter(Header);
